/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PutResponse } from '../../models/put-response';
import { TenantPosConfigInput } from '../../models/tenant-pos-config-input';

export interface DefaultConfigsConfigIdPut$Params {
  'Active-Tenant-Identifier': string;
  configId: string;
      body?: TenantPosConfigInput
}

export function defaultConfigsConfigIdPut(http: HttpClient, rootUrl: string, params: DefaultConfigsConfigIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<PutResponse>> {
  const rb = new RequestBuilder(rootUrl, defaultConfigsConfigIdPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('configId', params.configId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PutResponse>;
    })
  );
}

defaultConfigsConfigIdPut.PATH = '/default-configs/{configId}';
